import { render, staticRenderFns } from "./MentorshipRequestsCard.vue?vue&type=template&id=1ad64b42&scoped=true&"
import script from "./MentorshipRequestsCard.vue?vue&type=script&lang=js&"
export * from "./MentorshipRequestsCard.vue?vue&type=script&lang=js&"
import style0 from "./MentorshipRequestsCard.vue?vue&type=style&index=0&id=1ad64b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad64b42",
  null
  
)

export default component.exports